import { render, staticRenderFns } from "./TableStockActual.vue?vue&type=template&id=2268adfb"
import script from "./TableStockActual.vue?vue&type=script&lang=js"
export * from "./TableStockActual.vue?vue&type=script&lang=js"
import style0 from "./TableStockActual.vue?vue&type=style&index=0&id=2268adfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports